// eslint-disable-next-line import/prefer-default-export
export const STANDARDIZED_GRAPHQL_ERRORS = {
  UNAUTHORIZED_DRAFT_LISTING_ERROR: 'You are not authorized to access this draft listing',
  PUBLISHED_DRAFT_LISTING_ERROR: 'Attempting to update a published draft listing',
};
